import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityTrackerService {
  private activitySubject = new Subject<void>();
  public activity$ = this.activitySubject.asObservable();

  private lastActivityTime = Date.now();

  recordActivity() {
    this.lastActivityTime = Date.now();
    this.activitySubject.next();
  }

  getLastActivityTime(): number {
    return this.lastActivityTime;
  }
}
